<template>
  <div
    v-if="extensionDetails?.number"
    class="sip-register-toggle"
  >
    <input-switcher
      v-model="isUnregistered"
      :disabled="changingRegistration"
      :switcher-order="1"
      @update:modelValue="switchRegisterState"
    >
      <template #label>
        <p class="sip-register-toggle__label">
          <vsx-icon
            class="min-w-3.5"
            color="#999999"
            icon-name="InfoCircle"
            :size="14"
            type="linear"
          />
          {{ $t('account.mark_offline_automatically') }}
        </p>
      </template>
    </input-switcher>
  </div>
</template>

<script>
  import { useSipStore } from '@bv/stores';
  import { useUserStore } from '@bv/stores/user';
  import { sip } from '@bv/utils';
  import { mapState } from 'pinia';
  import { VsxIcon } from 'vue-iconsax';

  import InputSwitcher from '@/components/SharedComponents/Inputs/InputSwitcher.vue';

  export default {
    name: 'SipRegisterToggle',
    components: {
      InputSwitcher,
      VsxIcon,
    },
    data() {
      return {
        changingRegistration: false,
      };
    },
    computed: {
      ...mapState(useUserStore, ['extensionDetails']),
      ...mapState(useSipStore, ['isRegistered']),
      isUnregistered() {
        return !this.isRegistered;
      },
    },
    methods: {
      async switchRegisterState() {
        this.changingRegistration = true;
        await (this.isRegistered ? sip.unregister(true) : sip.register(true));
        this.changingRegistration = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sip-register-toggle {
    padding-block: 8px;
    border-block-start: 1px solid var(--gray50, #f2f2f2);
    border-block-end: 1px solid var(--gray50, #f2f2f2);
    display: flex;
    align-items: center;

    &__label {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      color: var(--gray400, #999);
      margin-inline-end: 8px;
    }
  }
</style>
